import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

export const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
});

export const database = app.database();
export const auth = app.auth();

export const usersRef = database.ref('users');
export const recentContentfulUpdateRef = database.ref('recentContentfulUpdate');
export const bookingsRef = database.ref('bookings');
export const anonymousBookingsRef = database.ref('anonymousBookings');

export const firebaseFunctions = axios.create({
  baseURL: process.env.REACT_APP_FIREBASE_FUNCTIONS_URL,
});

export default app;
